/**
 * 📢 Report Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - Report Server 연동
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';
import type { AxiosRequestConfig } from 'axios';

const getReportApiBaseUrl = (): string => {
  return process.env.REPORT_API_BASE_URL || 'https://api.ugot.uk';
};

const reportApiClientImpl = createOrvalCustomInstance(
  getReportApiBaseUrl(),
  {
    timeout: 30000,
    enableDebug: process.env.NODE_ENV === 'development',
    onAuthError: () => {
      console.warn('Report API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export function customInstance<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
) {
  return reportApiClientImpl<T>(config, options).then((data) => {
    // A misrouted API can return an SPA document with HTTP 200. Do not let
    // React Query treat that document as report data or render zero counts.
    if (typeof data === 'string' && data.trim() !== '') {
      throw new Error('신고 API가 올바른 JSON 응답을 반환하지 않았습니다.');
    }
    return data;
  });
}

export default customInstance;

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
